import type { CSSProperties } from "react";

/** 移动端滚轮日期选择器 */
export interface H5MobileDatePickerConfig {
  /** 单列选项高度（px） */
  itemHeight: number;
  /** 滚轮可见行数（奇数，中间为选中行） */
  visibleRows: number;
  /** 底部弹层圆角（px） */
  sheetRadius: number;
  /** 工具栏高度（px） */
  toolbarHeight: number;
  /** 工具栏按钮字号（px） */
  toolbarFontSize: number;
  /** 滚轮区高度（px，0 表示按 itemHeight * visibleRows 计算） */
  wheelHeight: number;
}

export const H5_MOBILE_DATE_PICKER_LAYOUT = {
  itemHeight: 44,
  visibleRows: 5,
  sheetRadius: 12,
  toolbarHeight: 48,
  toolbarFontSize: 15,
  wheelHeight: 0,
} as const satisfies H5MobileDatePickerConfig;

export function h5MobileDatePickerCssVars(): CSSProperties {
  const cfg = H5_MOBILE_DATE_PICKER_LAYOUT;
  const wheelHeight = cfg.wheelHeight || cfg.itemHeight * cfg.visibleRows;
  const padRows = Math.floor(cfg.visibleRows / 2);
  return {
    ["--h5-mobile-date-picker-item-height" as string]: `${cfg.itemHeight}px`,
    ["--h5-mobile-date-picker-visible-rows" as string]: String(cfg.visibleRows),
    ["--h5-mobile-date-picker-wheel-height" as string]: `${wheelHeight}px`,
    ["--h5-mobile-date-picker-wheel-pad" as string]: `${padRows * cfg.itemHeight}px`,
    ["--h5-mobile-date-picker-sheet-radius" as string]: `${cfg.sheetRadius}px`,
    ["--h5-mobile-date-picker-toolbar-height" as string]: `${cfg.toolbarHeight}px`,
    ["--h5-mobile-date-picker-toolbar-font-size" as string]: `${cfg.toolbarFontSize}px`,
  };
}
